<template>
  <li :class="{
    'menu__item': !hasChildren,
    'menu__item--dropdown': hasChildren,
    'dropdown-submenu': hasChildren && !isRoot
  }" @mouseenter="onItemMouseEnter" @mouseleave="onItemMouseLeave">
    <router-link
        :to="item.to"
        class="text-TTDrugs-regular-16"
        :class="{
          'text-uppercase': isRoot,
          'no-border': isLast,
          'dropdown-toggle': hasChildren && !isRoot
        }"
        @click.native.capture="handleClick">
      {{ item.label }}
      <span
        v-if="hasChildren && isMobileMenu"
        class="mobile-submenu-arrow"
        :class="{ 'mobile-submenu-arrow--open': showSubmenu }"
      />
    </router-link>

    <!-- Рекурсивный рендеринг дочерних элементов с условием отображения -->
    <ul v-if="hasChildren && showSubmenu"
        class="dropdown-menu"
        :class="{ 'dropdown-menu-level-3': !isRoot && hasChildren }"
        @mouseenter="showSubmenu = true"
        @mouseleave="showSubmenu = false">
      <menu-item
          v-for="(child, index) in item.children"
          :key="index"
          :item="child"
          :is-root="false"
          :is-menu-open="isMenuOpen"
          class="dropdown-item"
          :class="{ 'no-left-border': true }"
          @close="handleClose"
          :is-last="index === item.children.length - 1"
      />
    </ul>
  </li>
</template>

<script>
export default {
  name: 'MenuItem',
  props: {
    item: Object,
    isRoot: {
      type: Boolean,
      default: false
    },
    isLast: {
      type: Boolean,
      default: false
    },
    isMenuOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showSubmenu: false,
      isMobileMenu: false
    };
  },
  computed: {
    hasChildren() {
      return this.item.children && this.item.children.length > 0;
    }
  },
  watch: {
    isMenuOpen(newValue) {
      if (!newValue) {
        this.showSubmenu = false;
      }
    }
  },
  methods: {
    updateMobileState() {
      this.isMobileMenu = window.innerWidth <= 1090;
    },
    onItemMouseEnter() {
      if (this.isMobileMenu) {
        return;
      }
      this.showSubmenu = true;
    },
    onItemMouseLeave() {
      if (this.isMobileMenu) {
        return;
      }
      this.showSubmenu = false;
    },
    handleClick(event) {
      // В мобильном бургер-меню раскрываем подменю по нажатию (без перехода по ссылке)
      if (this.hasChildren && this.isMobileMenu) {
        event.preventDefault();
        event.stopPropagation();
        this.showSubmenu = !this.showSubmenu;
        return;
      }
      // На десктопе у родителя с подпунктами оставляем обычный переход по router-link;
      // подменю по-прежнему открывается по hover.
      this.$emit('close');
    },
    handleClose() {
      this.$emit('close');
    }
  },
  mounted() {
    this.updateMobileState();
    window.addEventListener('resize', this.updateMobileState);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateMobileState);
  }
}
</script>

<style scoped>
.dropdown-submenu {
  position: relative;
}

.dropdown-submenu > a,
.dropdown-item > a {
  display: block;
  width: 100%;
  box-sizing: border-box;
}

/* Стили для второго уровня (первые выпадающие меню) */
.dropdown-submenu > .dropdown-menu {
  top: 0;
  left: 100%;
  margin-top: -6px; /* Оставляем как было */
  margin-left: -1px;
  border-radius: 0 6px 6px 6px;
  display: block;
}

/* Стили для третьего уровня и глубже */
.dropdown-submenu .dropdown-menu-level-3 {
  top: 0;
  left: 100%;
  margin-top: -4px; /* Чуть меньше отступ для третьего уровня */
  margin-left: 0;
  border-radius: 0 4px 4px 4px;
}

/* Убираем левую границу для всех элементов глубокой вложенности */
.dropdown-item.no-left-border {
  border-left: none !important;
}

/* Если есть какие-то левые границы по умолчанию, убираем их */
.dropdown-menu-level-3 .dropdown-item,
.dropdown-menu-level-3 .dropdown-item:hover,
.dropdown-menu-level-3 .dropdown-item:focus {
  border-left: none;
  outline: none;
}

.dropdown-submenu > .dropdown-toggle:after {
  display: block;
  content: " ";
  float: right;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
  border-width: 5px 0 5px 5px;
  border-left-color: #ccc;
  margin-top: 5px;
  margin-right: -10px;
}

.dropdown-submenu:hover > .dropdown-toggle:after {
  border-left-color: #fff;
}

.dropdown-submenu.pull-left {
  float: none;
}

.dropdown-submenu.pull-left > .dropdown-menu {
  left: -100%;
  margin-left: 10px;
  border-radius: 6px 0 6px 6px;
}

.dropdown-menu {
  display: block;
  transition: opacity 0.2s ease;
}

/* Дополнительно: для третьего уровня убираем возможные фоновые полоски */
.dropdown-menu-level-3 .dropdown-item::before,
.dropdown-menu-level-3 .dropdown-item::after {
  display: none;
}

@media (max-width: 1090px) {
  .dropdown-menu {
    position: static;
    min-width: 100%;
    margin-top: 6px;
    border-radius: 10px;
    box-shadow: none;
  }

  .dropdown-submenu > .dropdown-menu,
  .dropdown-submenu .dropdown-menu-level-3 {
    top: auto;
    left: auto;
    margin-top: 6px;
    margin-left: 0;
    border-radius: 10px;
  }

  .dropdown-item {
    padding: 8px 12px;
  }

  .mobile-submenu-arrow {
    display: inline-block;
    width: 8px;
    height: 8px;
    margin-left: 10px;
    border-right: 2px solid #111;
    border-bottom: 2px solid #111;
    transform: rotate(45deg);
    transition: transform 0.2s ease;
    vertical-align: middle;
  }

  .mobile-submenu-arrow--open {
    transform: rotate(-135deg);
  }
}
</style>